

import React from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

const CustomTitle = ({ title, isIcon , textColor }) => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center space-x-3 font-inter">
      {isIcon && (
        <IoIosArrowBack
          className="text-customGreen cursor-pointer text-[33px]"
          onClick={() => {
            navigate(-1);
          }}
        />
      )}
      <h1 className={`text-[28px] text-nowrap font-semibold ${textColor === "primary" ? "text-customGreen" : "text-[#404040]"}`}>{title}</h1>
    </div>
  );
};

export default CustomTitle;
